// eslint-disable-next-line import/prefer-default-export
export { default as PrismicLink } from "./PrismicLink";
// export { default as CustomLink } from "./CustomLink";
